import { useState, useEffect } from "react";
import Layout from "../components/Layout";
import { motion } from "framer-motion";
import client from "../api/client";
import { toast } from "react-hot-toast";
import useAuth from "../auth/useAuth";

export default function Users() {
  const user = useAuth();
  const [users, setUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    username: "",
    password: "",
    role: "1", // Default rank
  });

  useEffect(() => {
    loadUsers();
    console.log(user);
  }, []);

  const loadUsers = async () => {
    const response = await client.get("/api/operators");
    if (response.ok) {
      setUsers(response.data);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await client.post("/api/operators", formData);
    if (response.ok) {
      toast.success("Utente creato con successo");
      setIsModalOpen(false);
      setFormData({
        first_name: "",
        last_name: "",
        email: "",
        username: "",
        password: "",
        role: "1",
      });
      loadUsers();
    } else {
      toast.error("Errore durante la creazione dell'utente");
    }
  };

  const handleDelete = async (id) => {
    if (user.user.id == id) return alert("Non puoi eliminare te stesso :(");
    if (window.confirm("Sei sicuro di voler eliminare questo utente?")) {
      const response = await client.delete(`/api/operators/${id}`);
      if (response.ok) {
        toast.success("Utente eliminato con successo");
        loadUsers();
      } else {
        toast.error("Errore durante l'eliminazione dell'utente");
      }
    }
  };

  const handleStatusToggle = async (user) => {
    const response = await client.put(`/api/operators/${user.id}`, {
      ...user,
      is_active: !user.is_active,
    });
    if (response.ok) {
      toast.success("Stato utente aggiornato");
      loadUsers();
    } else {
      toast.error("Errore durante l'aggiornamento dello stato");
    }
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setFormData({
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      username: user.username,
      password: "", // Leave password empty when editing
      role: user.role,
    });
    setIsEditModalOpen(true);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const response = await client.put(
      `/api/operators/${editingUser.id}`,
      formData
    );
    if (response.ok) {
      toast.success("Utente aggiornato con successo");
      setIsEditModalOpen(false);
      setEditingUser(null);
      loadUsers();
    } else {
      toast.error("Errore durante l'aggiornamento dell'utente");
    }
  };

  return (
    <Layout>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="p-6"
      >
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">Gestione Utenti</h1>
          <button
            className="btn btn-outline"
            onClick={() => setIsModalOpen(true)}
          >
            Nuovo Utente
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="table w-full">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Username</th>
                <th>Email</th>
                <th>Ruolo</th>
                <th>Ultimo Accesso</th>
                <th>Stato</th>
                <th>Azioni</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>
                    {user.first_name} {user.last_name}
                  </td>
                  <td>{user.username}</td>
                  <td>{user.email}</td>
                  <td>
                    {user.role === "operator"
                      ? "Operatore"
                      : user.role === "admin" && "Amministratore"}
                  </td>
                  <td>
                    {user.last_login
                      ? new Date(user.last_login).toLocaleString()
                      : "Mai"}
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      className="toggle toggle-success"
                      checked={user.is_active}
                      onChange={() => handleStatusToggle(user)}
                    />
                  </td>
                  <td>
                    <button
                      className="btn btn-warning btn-sm mr-2"
                      onClick={() => handleEdit(user)}
                    >
                      Modifica
                    </button>
                    <button
                      className="btn btn-error btn-sm"
                      onClick={() => handleDelete(user.id)}
                    >
                      Elimina
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Modal for new user */}
        {isModalOpen && (
          <div className="modal modal-open">
            <div className="modal-box">
              <h3 className="font-bold text-lg mb-4">Nuovo Utente</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Nome</span>
                  </label>
                  <input
                    type="text"
                    className="input input-bordered"
                    value={formData.first_name}
                    onChange={(e) =>
                      setFormData({ ...formData, first_name: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Cognome</span>
                  </label>
                  <input
                    type="text"
                    className="input input-bordered"
                    value={formData.last_name}
                    onChange={(e) =>
                      setFormData({ ...formData, last_name: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Email</span>
                  </label>
                  <input
                    type="email"
                    className="input input-bordered"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Username</span>
                  </label>
                  <input
                    type="text"
                    className="input input-bordered"
                    value={formData.username}
                    onChange={(e) =>
                      setFormData({ ...formData, username: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Password</span>
                  </label>
                  <input
                    type="password"
                    className="input input-bordered"
                    value={formData.password}
                    onChange={(e) =>
                      setFormData({ ...formData, password: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Ruolo</span>
                  </label>
                  <select
                    className="select select-bordered"
                    value={formData.role}
                    onChange={(e) =>
                      setFormData({ ...formData, role: e.target.value })
                    }
                  >
                    <option value="operator">Operatore</option>
                    <option value="admin">Amministratore</option>
                  </select>
                </div>
                <div className="modal-action">
                  <button type="submit" className="btn btn-primary">
                    Salva
                  </button>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => setIsModalOpen(false)}
                  >
                    Annulla
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Edit Modal */}
        {isEditModalOpen && (
          <div className="modal modal-open">
            <div className="modal-box">
              <h3 className="font-bold text-lg mb-4">
                Modifica Utente: {editingUser?.username}
              </h3>
              <form onSubmit={handleEditSubmit}>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Nome</span>
                  </label>
                  <input
                    type="text"
                    className="input input-bordered"
                    value={formData.first_name}
                    onChange={(e) =>
                      setFormData({ ...formData, first_name: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Cognome</span>
                  </label>
                  <input
                    type="text"
                    className="input input-bordered"
                    value={formData.last_name}
                    onChange={(e) =>
                      setFormData({ ...formData, last_name: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Email</span>
                  </label>
                  <input
                    type="email"
                    className="input input-bordered"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Username</span>
                  </label>
                  <input
                    type="text"
                    className="input input-bordered"
                    value={formData.username}
                    onChange={(e) =>
                      setFormData({ ...formData, username: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">
                      Password (lasciare vuoto per non modificare)
                    </span>
                  </label>
                  <input
                    type="password"
                    className="input input-bordered"
                    value={formData.password}
                    onChange={(e) =>
                      setFormData({ ...formData, password: e.target.value })
                    }
                  />
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Ruolo</span>
                  </label>
                  <select
                    className="select select-bordered"
                    value={formData.role}
                    onChange={(e) =>
                      setFormData({ ...formData, role: e.target.value })
                    }
                  >
                    <option value="operator">Operatore</option>
                    <option value="admin">Amministratore</option>
                  </select>
                </div>
                <div className="modal-action">
                  <button type="submit" className="btn btn-primary">
                    Aggiorna
                  </button>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => {
                      setIsEditModalOpen(false);
                      setEditingUser(null);
                    }}
                  >
                    Annulla
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </motion.div>
    </Layout>
  );
}
